import actions from '../utils/restActions';


export default (state = {}, action) => {
    
    switch (action.type) {

    case actions.streamings.index.status.success:

	return Object.assign({}, state, {list:  action.data});
 
    default:
	return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/Streamings.js